import { Injectable } from '@angular/core';
import { EntityListResolver } from 'src/app/core/services/entity-list.resolver';
import { LiftModuleList } from '../models/lift-module-list.model';
import { LiftModuleCriteria } from '../models/lift-module.criteria';
import { LiftParameterSettingsService } from './lift-parameter-settings.service';
import { LiftParameterSettingsCriteria } from '../models/lift-parameter-settings.criteria';
import { LiftBoardParameterService } from './lift-board-parameter.service';
import { LiftBoardParameterList } from '../models/lift-board-parameter-list.model';
import { LiftBoardParameterCriteria } from '../models/lift-board-parameter.criteria';

@Injectable({
  providedIn: 'root'
})
export class LiftBoardParameterListResolver extends EntityListResolver<LiftBoardParameterService, LiftBoardParameterList, LiftBoardParameterCriteria> {
  constructor(
    liftBoardParameterService: LiftBoardParameterService
  ) {
    let criteria = new LiftBoardParameterCriteria();
    criteria.liftBoardId = 1;
    super(liftBoardParameterService, criteria);
  }
}
